import React from "react";

// Renders a bright warning strip whenever the site is opened via the
// preview URL — data typed here NEVER lands on the live restaurant DB.
export default function PreviewBanner() {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname;
  const isPreview = host.endsWith("preview.emergentagent.com") || host.endsWith("emergentagent.com");
  if (!isPreview) return null;

  return (
    <div
      data-testid="preview-banner"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 9999,
        background: "#7A0F14",
        color: "#fff",
        padding: "8px 14px",
        fontSize: 13,
        lineHeight: 1.35,
        textAlign: "center",
        boxShadow: "0 1px 0 rgba(0,0,0,0.15)",
      }}
    >
      <strong>PREVIEW ONLY</strong> &mdash; punches &amp; stock saved here do
      <b> NOT</b> appear on the live site.&nbsp;
      <a
        href="https://royalwowmeals.com"
        style={{ color: "#FFD54F", textDecoration: "underline", fontWeight: 600 }}
        data-testid="preview-banner-live-link"
      >
        Open royalwowmeals.com &rarr;
      </a>
    </div>
  );
}
